import { render, staticRenderFns } from "./LinksBox.vue?vue&type=template&id=8a249854&scoped=true&"
import script from "./LinksBox.vue?vue&type=script&lang=js&"
export * from "./LinksBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a249854",
  null
  
)

export default component.exports